import gql from 'graphql-tag';

import { executeGqlMutation } from 'src/graphql/client';
import { getSingleProp } from 'src/lib/graphql';

import { FRAGMENT_BRAND_VOICE } from './schema';

const MUTATION = gql`
  mutation UpdateBrandVoice($id: ID!, $name: String!, $language: String) {
    updateBrandVoice(id: $id, name: $name, language: $language) {
      ...BrandVoice
    }
  }
  ${FRAGMENT_BRAND_VOICE}
`;

export const updateBrandVoice = ({ id, name, language }) => {
  const variables = {
    id,
    name,
    language,
  };

  return executeGqlMutation({
    mutation: MUTATION,
    variables,
  }).then(({ data }) => getSingleProp(data));
};
